
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  flex-grow:1;
  display:flex;
  flex-direction:column;
  position:relative;
  height:100%;
}

:host([high-contrast]) div[slot='body']{
  color:var(--brand-white);
}

:host([high-contrast]) div[slot='body'] outline-styled-text-baseline *{
    color:var(--brand-white);
  }

.container{
  flex-grow:1;
}

.container.card-image{
    background-color:transparent;
    position:relative;
  }

.container.light-gray-bg{
    background-color:var(--brand-gray-200);
  }

.container.dark-blue-bg{
    background-color:var(--brand-primary-dark-blue);
  }

.container.white-bg{
    background-color:var(--brand-white);
    box-shadow:0 0 10px 5px rgba(4, 30, 74, 0.1);
  }

.container.light-blue-bg{
    background-color:var(--brand-primary-blue);
  }

.container.green-bg{
    background-color:var(--brand-primary-green);
  }

.content{
  display:flex;
  flex-direction:column;
  padding:var(--spacing-5);
  padding:var(--cta-card-content-padding, var(--spacing-5));
  height:100%;
}

@media (min-width: 768px){

.content{
    padding:var(--spacing-10);
    padding:var(--cta-card-content-padding, var(--spacing-10))
}
  }

.card-image .content{
  padding:0;
}

@media (min-width: 768px){

.card-image .content{
    padding:0
}
  }

.cta{
  flex-grow:1;
  display:flex;
  align-items:flex-end;
}

.card-image .cta{
  flex-grow:0;
}

div[slot='heading']{
  margin-bottom:var(--spacing-4);
  margin-bottom:var(--cta-heading-margin, var(--spacing-4));
}

div[slot='body']{
  margin-bottom:var(--spacing-6);
  margin-bottom:var(--cta-body-margin, var(--spacing-6));
  color:var(--brand-gray-800);
  font-size:var(--fs-lg);
  font-size:var(--cta-body-font-size, var(--fs-lg));
}

@media (min-width: 768px){

div[slot='body']{
    font-size:1.375rem;
    font-size:var(--cta-body-font-size, 1.375rem)
}
  }

div[slot='image']{
  width:100%;
  height:100%;
}

div[slot='image'] img{
    height:100%;
    object-fit:cover;
    width:100%;
  }

.image{
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:100%;
  overflow:hidden;
  z-index:0;
}

.card-image-content-wrapper{
  display:flex;
  flex:1 0 auto;
  flex-direction:column;
  height:100%;
  justify-content:center;
  max-width:22.5rem;
  padding:1.875rem;
  position:relative;
  width:100%;
  z-index:1;
}

@media (min-width: 768px){

.card-image-content-wrapper{
    min-height:26rem
}
  }
`;